// Auto-generated resource for System — DO NOT EDIT.
// Regenerate via `dotnet run --project backend/tools/BackendTypesGenerator`.
// Projection of the backend resource JSON — keys, value catalogs (per
// culture), and string-literal unions. Hand-editing drifts from the source.

export const SystemKeys = {
  Messages: {
    ValidationTitle: 'System.Messages.ValidationTitle',
    ValidationError: 'System.Messages.ValidationError',
    OperationSuccess: 'System.Messages.OperationSuccess',
    OperationFailure: 'System.Messages.OperationFailure',
    UserProfileNotFound: 'System.Messages.UserProfileNotFound',
    ProjectionRebuildStarted: 'System.Messages.ProjectionRebuildStarted',
    ProjectionNotRebuildable: 'System.Messages.ProjectionNotRebuildable',
    UnknownProjectionType: 'System.Messages.UnknownProjectionType',
    DeadLetterIdsRequired: 'System.Messages.DeadLetterIdsRequired',
    DeadLettersReplayQueued: 'System.Messages.DeadLettersReplayQueued',
    DeadLettersDiscarded: 'System.Messages.DeadLettersDiscarded',
    AccountDeletionNotPending: 'System.Messages.AccountDeletionNotPending',
    UnknownAccountDeletionLeg: 'System.Messages.UnknownAccountDeletionLeg',
    InvalidListCursor: 'System.Messages.InvalidListCursor',
    AiProviderUnavailable: 'System.Messages.AiProviderUnavailable',
    StorageUnavailable: 'System.Messages.StorageUnavailable',
    AccessVerificationUnavailable: 'System.Messages.AccessVerificationUnavailable',
    NotAuthorized: 'System.Messages.NotAuthorized',
    BotCheckFailed: 'System.Messages.BotCheckFailed',
  },
} as const;

export const SystemValues = {
  'default': {
    'Messages.AccessVerificationUnavailable': 'Sign-in verification is temporarily unavailable. Please try again in a few minutes.',
    'Messages.AccountDeletionNotPending': 'No account deletion is in flight for this user',
    'Messages.AiProviderUnavailable': 'The AI service is temporarily unavailable. Nothing was charged — please try again in a few minutes.',
    'Messages.BotCheckFailed': 'We couldn’t verify that this request came from a person. Please try again, or email us.',
    'Messages.DeadLetterIdsRequired': 'At least one dead-letter envelope id is required',
    'Messages.DeadLettersDiscarded': 'Discarded {0} dead-letter envelope(s)',
    'Messages.DeadLettersReplayQueued': 'Marked {0} dead-letter envelope(s) for replay',
    'Messages.InvalidListCursor': 'The list cursor is not valid; reload the list.',
    'Messages.NotAuthorized': 'You are not allowed to do that.',
    'Messages.OperationFailure': 'The operation could not be completed. Please try again later',
    'Messages.OperationSuccess': 'Operation completed successfully',
    'Messages.ProjectionNotRebuildable': 'Projection {0} is not a rebuildable async projection',
    'Messages.ProjectionRebuildStarted': 'Rebuilding {0} projection',
    'Messages.StorageUnavailable': 'Recording storage is temporarily unavailable. Please try again in a few minutes.',
    'Messages.UnknownAccountDeletionLeg': 'Unknown account-deletion leg: {0}',
    'Messages.UnknownProjectionType': 'Unknown projection type: {0}',
    'Messages.UserProfileNotFound': 'User profile not found',
    'Messages.ValidationError': 'One or more validation errors occurred.',
    'Messages.ValidationTitle': 'Validation Error',
  },
  'vi-VN': {
    'Messages.AccessVerificationUnavailable': 'Xác minh đăng nhập tạm thời không khả dụng. Vui lòng thử lại sau vài phút.',
    'Messages.AccountDeletionNotPending': 'Không có yêu cầu xoá tài khoản nào đang chờ cho người dùng này',
    'Messages.AiProviderUnavailable': 'Dịch vụ AI tạm thời không khả dụng. Bạn chưa bị tính phí — vui lòng thử lại sau vài phút.',
    'Messages.BotCheckFailed': 'Chúng tôi không thể xác minh yêu cầu này do một người gửi. Vui lòng thử lại, hoặc gửi email cho chúng tôi.',
    'Messages.DeadLetterIdsRequired': 'Cần ít nhất một id của bản tin lỗi',
    'Messages.DeadLettersDiscarded': 'Đã xoá {0} bản tin lỗi',
    'Messages.DeadLettersReplayQueued': 'Đã đánh dấu {0} bản tin lỗi để chạy lại',
    'Messages.InvalidListCursor': 'Con trỏ danh sách không hợp lệ; hãy tải lại danh sách.',
    'Messages.NotAuthorized': 'Bạn không được phép làm việc đó.',
    'Messages.OperationFailure': 'Không thể hoàn thành thao tác. Vui lòng thử lại sau',
    'Messages.OperationSuccess': 'Thao tác đã hoàn thành thành công',
    'Messages.ProjectionNotRebuildable': 'Projection {0} không phải là projection bất đồng bộ có thể dựng lại',
    'Messages.ProjectionRebuildStarted': 'Đang dựng lại projection {0}',
    'Messages.StorageUnavailable': 'Kho lưu trữ bản ghi tạm thời không khả dụng. Vui lòng thử lại sau vài phút.',
    'Messages.UnknownAccountDeletionLeg': 'Nhánh xoá tài khoản không xác định: {0}',
    'Messages.UnknownProjectionType': 'Loại projection không xác định: {0}',
    'Messages.UserProfileNotFound': 'Không tìm thấy hồ sơ người dùng',
    'Messages.ValidationError': 'Đã xảy ra một hoặc nhiều lỗi xác thực.',
    'Messages.ValidationTitle': 'Lỗi Xác Thực',
  },
} as const;

